import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 300000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

// Shared error handler for both form submissions
function handleApiError(error) {
  if (error.code === 'ERR_NETWORK' || error.message.includes('Network Error')) {
    throw new Error('Cannot connect to server. Please check your internet connection.');
  }
  if (error.code === 'ECONNREFUSED') {
    throw new Error('Server is not responding. Please try again later.');
  }
  if (error.code === 'ECONNABORTED' && error.message.includes('timeout')) {
    throw new Error('Request timed out. Your submission may have been sent. Please check and try again if needed.');
  }
  if (error.response?.data?.error) {
    throw new Error(error.response.data.error);
  }
  throw new Error('Failed to submit. Please try again.');
}

// Contact form submission
export const submitContact = async (data) => {
  try {
    const response = await axiosInstance.post('/api/contacts', data);
    if (response.data.status !== 'success') {
      throw new Error(response.data.message || 'Submission failed');
    }
    return response;
  } catch (error) {
    handleApiError(error);
  }
};

// Career form submission
export const submitCareer = async (data) => {
  try {
    const response = await axiosInstance.post('/api/careers', data);
    if (response.data.status !== 'success') {
      throw new Error(response.data.message || 'Submission failed');
    }
    return response;
  } catch (error) {
    handleApiError(error);
  }
};
